import { observable, runInAction } from 'mobx';

class CmsDataStore {
  @observable private accessor data: { [key: string]: any } = {};

  public setData(key: string, value: any) {
    runInAction(() => (this.data = { ...this.data, [key]: value }));
  }

  public getData(key: string): any {
    const path = key.split('.');

    let value = this.data[path.shift()];

    while (value != null && path.length > 0) {
      value = value[path.shift()];
    }

    return value;
  }
}

export default CmsDataStore;
